import { Controller } from "@hotwired/stimulus"
import { money, number, read } from "../../lib/format"

// The hourly rate that reaches an after-tax income goal on the billable hours.
export default class extends Controller {
  static targets = ["goal", "period", "tax", "hours", "weeks", "rate", "billable", "gross"]

  connect() { this.compute() }

  compute() {
    const goal = read(this.goalTarget) * (this.periodTarget.value === "month" ? 12 : 1)
    const taxRate = Math.min(read(this.taxTarget), 99) / 100
    const gross = goal / (1 - taxRate)
    const billable = read(this.hoursTarget) * read(this.weeksTarget)

    this.grossTarget.textContent = money(gross)
    this.billableTarget.textContent = number(billable)
    this.rateTarget.textContent = billable > 0 ? money(gross / billable) : "—"
  }
}
